import { render } from "./ElementSection.vue?vue&type=template&id=6dfad660&scoped=true"
import script from "./ElementSection.vue?vue&type=script&lang=js"
export * from "./ElementSection.vue?vue&type=script&lang=js"

import "./ElementSection.vue?vue&type=style&index=0&id=6dfad660&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dfad660"]])

export default __exports__